import { URL } from "../../utils/UrlConstants";
import { privateFetch } from "../../utils/CustomFetch.js";
import { CONSTANT } from "../../utils/Constants";

// ────────────────────────────── Staff List ──────────────────────────────────

export const getStaffListsByProject = async (projectId: number) => {
  const response = await privateFetch.get(
    URL.REQUEST_STAFF_LIST_BY_PROJECT(projectId)
  );
  return response.data;
};

export const createStaffList = async (data: any) => {
  const response = await privateFetch.post(
    URL.REQUEST_STAFF_LIST,
    JSON.stringify(data),
    { headers: { ...CONSTANT.HEADER_TYPE } }
  );
  return response.data;
};

export const updateStaffList = async (data: any) => {
  const response = await privateFetch.put(
    URL.REQUEST_STAFF_LIST,
    JSON.stringify(data),
    { headers: { ...CONSTANT.HEADER_TYPE } }
  );
  return response.data;
};

export const deleteStaffList = async (id: number) => {
  const response = await privateFetch.delete(URL.REQUEST_STAFF_LIST, {
    data: { id },
    headers: { ...CONSTANT.HEADER_TYPE },
  });
  return response.data;
};

// ────────────────────────────── Staff List Member ───────────────────────────

export const getMembersByStaffList = async (staffListId: number) => {
  const response = await privateFetch.get(
    URL.REQUEST_STAFF_LIST_MEMBERS_BY_LIST(staffListId)
  );
  return response.data;
};

export const createStaffListMember = async (data: any) => {
  const response = await privateFetch.post(
    URL.REQUEST_STAFF_LIST_MEMBER,
    JSON.stringify(data),
    { headers: { ...CONSTANT.HEADER_TYPE } }
  );
  return response.data;
};

export const deleteStaffListMember = async (id: number) => {
  const response = await privateFetch.delete(URL.REQUEST_STAFF_LIST_MEMBER, {
    data: { id },
    headers: { ...CONSTANT.HEADER_TYPE },
  });
  return response.data;
};

// ────────────────────────────── Project Sender ──────────────────────────────

export const getProjectSender = async (projectId: number) => {
  const response = await privateFetch.get(
    URL.REQUEST_PROJECT_SENDER_BY_PROJECT(projectId)
  );
  return response.data;
};

export const saveProjectSender = async (data: any) => {
  if (data.id) {
    const response = await privateFetch.put(
      URL.REQUEST_PROJECT_SENDER,
      JSON.stringify(data),
      { headers: { ...CONSTANT.HEADER_TYPE } }
    );
    return response.data;
  } else {
    const response = await privateFetch.post(
      URL.REQUEST_PROJECT_SENDER,
      JSON.stringify(data),
      { headers: { ...CONSTANT.HEADER_TYPE } }
    );
    return response.data;
  }
};

// ────────────────────────────── Project Vehicle ─────────────────────────────

export const getProjectVehicle = async (projectId: number) => {
  const response = await privateFetch.get(
    URL.REQUEST_PROJECT_VEHICLE_BY_PROJECT(projectId)
  );
  return response.data;
};

export const saveProjectVehicle = async (data: any) => {
  if (data.id) {
    const response = await privateFetch.put(
      URL.REQUEST_PROJECT_VEHICLE,
      JSON.stringify(data),
      { headers: { ...CONSTANT.HEADER_TYPE } }
    );
    return response.data;
  } else {
    const response = await privateFetch.post(
      URL.REQUEST_PROJECT_VEHICLE,
      JSON.stringify(data),
      { headers: { ...CONSTANT.HEADER_TYPE } }
    );
    return response.data;
  }
};

// ────────────────────────────── Project Signature ───────────────────────────

export const getProjectSignature = async (projectId: number) => {
  const response = await privateFetch.get(
    URL.REQUEST_PROJECT_SIGNATURE_BY_PROJECT(projectId)
  );
  return response.data;
};

export const saveProjectSignature = async (data: any) => {
  if (data.id) {
    const response = await privateFetch.put(
      URL.REQUEST_PROJECT_SIGNATURE,
      JSON.stringify(data),
      { headers: { ...CONSTANT.HEADER_TYPE } }
    );
    return response.data;
  } else {
    const response = await privateFetch.post(
      URL.REQUEST_PROJECT_SIGNATURE,
      JSON.stringify(data),
      { headers: { ...CONSTANT.HEADER_TYPE } }
    );
    return response.data;
  }
};

// ────────────────────────────── Seed Default Data ───────────────────────────

export const seedProjectDefaultData = async (projectId: number) => {
  const response = await privateFetch.post(
    URL.REQUEST_SEED_DEFAULT_DATA(projectId)
  );
  return response.data;
};

// ────────────────────────────── Report Downloads ────────────────────────────

export const downloadStaffListPdf = async (staffListId: number, returnBlob = false) => {
  const response = await privateFetch.get(
    URL.REQUEST_STAFF_LIST_PDF(staffListId),
    { responseType: "blob" }
  );
  if (returnBlob) return response.data;
  
  const blob = new Blob([response.data], { type: "application/pdf" });
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = `lista_personal_${staffListId}.pdf`;
  link.click();
  window.URL.revokeObjectURL(link.href);
};

export const downloadStaffListWord = async (staffListId: number) => {
  const response = await privateFetch.get(
    URL.REQUEST_STAFF_LIST_WORD(staffListId),
    { responseType: "blob" }
  );
  const blob = new Blob([response.data], {
    type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  });
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = `lista_personal_${staffListId}.docx`;
  link.click();
  window.URL.revokeObjectURL(link.href);
};
